import _defineProperty from '@babel/runtime/helpers/defineProperty';
import toRgbColor from '../../util/toRgbColor.js';
import { Box } from '../Box/Box.js';
import styled from 'styled-components';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ToggleInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "Togglestyled__ToggleInput",
  componentId: "sc-10zy573-0"
})(function (props) {
  if (!props.$outlineColor) return {};
  var outlineColor = toRgbColor(props.$outlineColor);
  return _objectSpread({
    position: 'absolute',
    opacity: 0,
    cursor: 'inherit',
    userSelect: 'none',
    '-webkit-tap-highlight-color': 'transparent'
  }, !props.isToggleButtonAccessibilityColorFix && {
    '&:focus-visible + div': {
      // TODO: ADSWEB-729 Token for outline width
      outline: "4px solid rgba(".concat(outlineColor.red, ", ").concat(outlineColor.green, ", ").concat(outlineColor.blue, ", 0.5)"),
      '&::after': {
        /* stylelint-disable-next-line string-quotes */
        content: '""',
        position: 'absolute',
        backgroundColor: props.$outlineColor,
        width: '100%',
        height: '100%',
        borderRadius: '999px',
        opacity: 0.12
      }
    }
  });
});
var ToggleKnobContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Togglestyled__ToggleKnobContainer",
  componentId: "sc-10zy573-1"
})(function (props) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    transition: 'transform 0.2s ease-in-out, top 0.2s ease-in-out, left 0.2s ease-in-out, right 0.2s ease-in-out',
    '&::after': {
      /* stylelint-disable-next-line string-quotes */
      content: '""',
      position: 'absolute',
      display: 'block',
      transition: 'opacity 0.2s ease-in-out, width 0.2s ease-in-out, height 0.2s ease-in-out',
      borderRadius: '50%',
      top: '0',
      bottom: '0',
      margin: 'auto',
      opacity: 0,
      width: 0,
      height: 0,
      backgroundColor: props.$rippleColor
    },
    '&:hover::after': {
      width: props.$rippleSize,
      height: props.$rippleSize,
      opacity: 0.08
    },
    '&:active::after': {
      width: props.$rippleSize,
      height: props.$rippleSize,
      opacity: 0.16
    }
  };
});

export { ToggleInput, ToggleKnobContainer };
//# sourceMappingURL=Toggle.styled.js.map
